import { setConfirmJoinOrganizationModal } from '../../../../../store/workspace/slice';
import { updateInvitedMemberInfoThunk } from '../../../../../store/workspace/thunks';
import { InviteMemberIcon, JoinOrganizationIcon } from '../../../../../assets/icons';
import { selectInviteMemberToken } from '../../../../../store/workspace/selectors';
import { setSignUpMode, setSignUpStep } from '../../../../../store/signUp/slice';
import { setAccessToProtectedRoutes } from '../../../../../store/auth/slice';
import { useDispatch, useSelector } from '../../../../../store/store';
import { selectEmail } from '../../../../../store/signUp/selectors';
import Button from '../../../../../components/Button';
import Modal from '../../../../../components/Modal';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import styles from './style.module.scss';

interface UserInfo {
    companyName: string;
    firstName: string;
    lastName: string;
    role: string;
};

export default function ConfirmJoinOrganization() {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const userEmail = useSelector(selectEmail);
    const [isLoading, setIsLoading] = useState(false);
    const token = useSelector(selectInviteMemberToken);
    const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

    useEffect(() => {
        const info = {
            token,
            email: userEmail,
        };

        dispatch(updateInvitedMemberInfoThunk(info))
            .unwrap()
            .then((res) => {
                console.log(res);

                setUserInfo(res)
            })
            .catch((error) => {
                setIsLoading(false);
            })
    }, []);

    const next = () => {

        if (!userInfo?.firstName || !userInfo.lastName || !userInfo.role) {
            dispatch(setAccessToProtectedRoutes(true));
            dispatch(setSignUpMode('Member'));
            dispatch(setSignUpStep('memberInfo'));
            dispatch(setConfirmJoinOrganizationModal(false));
            navigate('/signup');
            return;
        }

        setIsLoading(true);
        const info = {
            token,
            email: userEmail,
            role: userInfo.role,
            lastName: userInfo.lastName,
            firstName: userInfo.firstName,
        };

        dispatch(updateInvitedMemberInfoThunk(info))
            .unwrap()
            .then(() => {
                window.location.reload();
            })
            .catch((error) => {
                setIsLoading(false);
            })
    };

    return (
        <Modal
            size='sm'
            icon={<InviteMemberIcon />}
            title='Become a member'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setConfirmJoinOrganizationModal(false))}
        >
            <JoinOrganizationIcon />
            <p>
                Are you accepting the invitation from <b>{userInfo?.companyName}</b> to
                become a member of this organization account?
            </p>

            <div className={styles.actions}>
                <Button
                    type='Outline-Primary'
                    text='Cancel'
                    disabled={isLoading}
                    className={styles.actions_btn}
                    onClick={() => dispatch(setConfirmJoinOrganizationModal(false))}
                />
                <Button
                    type='Primary'
                    onClick={next}
                    loading={isLoading}
                    className={styles.actions_btn}
                    text='Confirm'
                />
            </div>
        </Modal>
    )
}
